import { Component, Input, OnInit } from '@angular/core';
import { ApplicationListDetail } from '../../model/application/application-list-detail.model';
import { ItemStatus } from '../../../shared/enums/item-status.enum';
import { Store } from '@ngrx/store';
import { ApplicationDetail } from '../../model/application/application-detail.model';
import * as application from '../../actions/application-detail.actions';
import { AccountGroup } from '../../../../core/model/account-group/account-group.model';
import { ApplicationsState } from '../../applications.state';
import { selectBackupApplicationDetails, selectApplicationDetails, selectExpandedApplicationList } from '../../application.selector';
import { findExpandedApp, isExpandedApp } from '../../services/applications.helper';
import * as RouterActions from '../../../../core/actions/router.actions';
import { ContainerComponent } from '../../../shared/components/container-component/unsubscribe.component';
import { ApplicationMap } from '../../model/modified-applications.model';
import { equalEnabledOnAccountGroups } from '../../../../core/helpers/account-group.helper';
import { ToggleEnableProductPayload } from '../../actions/application-detail.actions';
import { ModuleRoutingConstants } from '../../../../core/helpers/module-routing.constants';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/operator/takeUntil';

@Component({
    selector: 'ssf-application-list-item',
    template: require('./application-list-item.component.html'),
    styles: [require('./application-list-item.component.scss')]
})
export class ApplicationListItemComponent extends ContainerComponent implements OnInit {
    @Input() application: ApplicationListDetail;
    @Input() itemStatus: ItemStatus;
    public i18n = 'APPLICATIONS.APPLICATION-LIST-ITEM.';

    applicationDetail: ApplicationDetail;
    dirty = false;

    /**
     * Flag to instruct accordion component if detail is expanded / collapsed.
     * It can not be driven by the presence of the application detail only (applicationDetail !== null) because of
     * animations.
     *
     * We need to keep applicationDetail to reference an object while collapsing the accordion otherwise child components
     * collapse immediately (they lost data) and slide effect doesn't not look good.
     *
     * @type {boolean}
     */
    isExpanded = false;


    constructor(private store: Store<ApplicationsState>) {
        super();
    }

    ngOnInit(): void {
        const applicationDetail$ = this.store.select(selectExpandedApplicationList)
            .combineLatest(this.store.select(selectApplicationDetails))
            .map(([expanded, details]) => {
                this.isExpanded = isExpandedApp(this.application.appId, expanded);
                return findExpandedApp(this.application.appId, expanded, details);
            });

        applicationDetail$
            .takeUntil(this.ngUnsubscribe)
            .filter(applicationDetail => !!applicationDetail)
            .subscribe((applicationDetail) => {
                this.applicationDetail = applicationDetail;
            });

        applicationDetail$
            .takeUntil(this.ngUnsubscribe)
            .filter(detail => !!detail)
            .withLatestFrom(this.store.select(selectBackupApplicationDetails))
            .map(([detail, backupApplicationDetails]: ([ApplicationDetail, ApplicationMap])) =>
                equalEnabledOnAccountGroups(backupApplicationDetails[detail.appId].accountsGroups, detail.accountsGroups))
            .subscribe(same => this.dirty = !same);
    }

    onItemClick(item: ApplicationListDetail) {
        this.store.dispatch(new application.ToggleDetailAction(item));
    }

    onAccountGroupClick(accountGroup: AccountGroup) {
        this.store.dispatch(new application.ToggleAccountGroupAction({
            appId: this.application.appId,
            accountGroup
        }));
    }

    onEnableProduct({accountGroup, product}) {
        this.store.dispatch(new application.ToggleEnableProductAction(<ToggleEnableProductPayload>{
            appId: this.application.appId,
            accountGroup,
            product
        }));
    }

    onSaveChanges() {
        if (!this.dirty) {
            return;
        }
        this.store.dispatch(new application.UpdatePermissionsAction(this.application.appId));
    }

    onDeleteApplication() {
        this.store.dispatch(new application.DeleteAction(this.application));
    }

    revertChanges() {
        if (!this.dirty) {
            return;
        }
        this.store.dispatch(new application.RevertPermissionsRequestAction(this.application.appId));
    }

    onShowHistory() {
        this.store.dispatch(
            new RouterActions.Go({
                path: ModuleRoutingConstants.HISTORY_OF_REQUESTS_ROUTER,
                query: {
                    appId: this.application.appId,
                    appName: this.application.name
                },
            }));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/components/application-list-item/application-list-item.component.ts